<template>
    <div>
        <b-row>
            <b-col sm="2">
                <InputNumber title="Federais %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled"
                    v-model="transparencia.percentualTotalTributosFederais" />
            </b-col>
            <b-col sm="2">
                <InputNumber title="Estaduais %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled"
                    v-model="transparencia.percentualTotalTributosEstaduais" />
            </b-col>
            <b-col sm="2">
                <InputNumber title="Municipais %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled"
                    v-model="transparencia.percentualTotalTributosMunicipais" />
            </b-col>
        </b-row>
        <b-row v-if="id">
            <b-col sm="2">
                <InputDecimal title="Federais R$" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true"
                    v-model="transparencia.valorTotalTributosFederais" />
            </b-col>
            <b-col sm="2">
                <InputDecimal title="Estaduais R$" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true"
                    v-model="transparencia.valorTotalTributosEstaduais" />
            </b-col>
            <b-col sm="2">
                <InputDecimal title="Municipais R$" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true"
                    v-model="transparencia.valorTotalTributosMunicipais" />
            </b-col>
        </b-row>
    </div>
</template>

<script>

import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";

import NfseNacional from "./NfseNacional.js";

import { mapActions } from "vuex";

export default {
    name: "Transparencia",
    props: ["disabled", "ehSimplesNacional", "value"],
    components: {
        InputDecimal, InputNumber
    },
    data() {
        return {
            id: this.$route.params.id,
            transparencia: new NfseNacional().transparencia,
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
            loading: false,
        }
    },
    mounted() {
        if (!this.id) this.obterRegimeTributarioEmpresa();
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };
            this.getApi(params).then((response) => {
                if (response && response.success) {
                    const data = response.content || {};
                    this.transparencia.percentualTotalTributosFederais = data.percentualTotalTributosFederais;
                    this.transparencia.percentualTotalTributosEstaduais = data.percentualTotalTributosEstaduais;
                    this.transparencia.percentualTotalTributosMunicipais = data.percentualTotalTributosMunicipais;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (this.id) this.transparencia = value;
            }
        },
        transparencia: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
}
</script>
